export default {
  _id: 500,
  getid () {
    return this._id++
  }
}
